var map = {
	"./00.png": 1985,
	"./01.png": 856,
	"./02.png": 2819,
	"./03.png": 906,
	"./04.png": 1333,
	"./05.png": 5420,
	"./06.png": 2999,
	"./07.png": 3502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1301;